// extracted by mini-css-extract-plugin
module.exports = {"bookingHeader":"Style_bookingHeader__3u310","title":"Style_title__34XWV","text":"Style_text__1hcpY"};